import { Field } from 'formik';
import { FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

function InputFormGroup({
  type,
  name,
  label,
  pattern,
  title,
  placeholder,
  required,
  disabled,
}) {
  const redStyle = { color: 'rgb(230, 0, 0)' };
  const theType = type || 'text';

  return (
    <Field name={name}>
      {({ field }) => (
        <FormGroup controlId={field.name}>
          <FormLabel>
            {required ? <span style={redStyle}>*</span> : ''}
            {label}
          </FormLabel>
          <FormControl
            type={theType}
            required={required}
            {...field}
            pattern={pattern}
            title={title}
            placeholder={placeholder}
            disabled={disabled}
          />
        </FormGroup>
      )}
    </Field>
  );
}

InputFormGroup.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  pattern: PropTypes.string,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};
export default InputFormGroup;
